import { createRouter } from '@tanstack/react-router';
import { shortIdRewrite } from '@hlt/web-kit/shell';
import type { QueryClient } from '@tanstack/react-query';
import { routeTree } from '@/routeTree.gen';

export interface RouterContext {
    queryClient: QueryClient;
}

export function createAppRouter(queryClient: QueryClient) {
    return createRouter({
        routeTree,
        context: { queryClient },
        defaultPreload: 'intent',
        // Short identifiers in the address bar; routes and API calls keep using UUIDs.
        rewrite: shortIdRewrite,
        scrollRestoration: true,
        defaultPendingMs: 400,
    });
}

declare module '@tanstack/react-router' {
    interface Register {
        router: ReturnType<typeof createAppRouter>;
    }
}
